import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { UserService } from '../_services/user.service';
import { PricingService } from '../_services/pricing.service';
import { IPagination } from '../_models/pagination';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ProductModel } from '../_cart/product-model';
import { CartService } from '../_services/cart.service';
import { environment } from '../../environments/environment';
import { StoreService } from '../_services/store.service';
import { User } from '../_models/user';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from '../_constants/constants';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { WishlistService } from '../_services/wishlist.service';

@Component({
    selector: 'app-header-new',
    templateUrl: './header-new.component.html',
    styleUrls: ['./header-new.component.css'],
    standalone: false
})
export class HeaderNewComponent implements OnInit, OnDestroy {
    pricing: any[];

    products: Observable<ProductModel[]>;

    total = 0;

    user: User = null;

    nbrOfTypeOfProductsInCart = 0;

    appCurrentLang: string;

    availableLangs: string[] = [AppConstants.FRENCH, AppConstants.ENGLISH];
    currentLanguage: string | null = null;

    searchForm: UntypedFormGroup;

    wishlistCount = 0;

    // NEW: tracks whether we're on the marketplace route
    isMarketplacePage = false;
    mobileSearchOpen = false;

    private langChangeSubscription: Subscription;
    private routerEventsSubscription: Subscription; // NEW

    constructor(
        public userService: UserService,
        private router: Router,
        private cartService: CartService,
        private storeService: StoreService,
        private pricingService: PricingService,
        private translationService: TranslateService,
        private fb: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private translateService: TranslateService,
        private wishlistService: WishlistService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
        }
        this.nbrOfTypeOfProductsInCart = this.storeService.productModels.length;
        this.searchForm = this.fb.group({
            q: new UntypedFormControl('', Validators.required)
        });

        // NEW: set initial state + listen for route changes
this.isMarketplacePage = this.router.url.includes('/marketplace') || this.router.url.includes('/products') || this.router.url.includes('/search');
        this.routerEventsSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.isMarketplacePage = event.urlAfterRedirects.includes('/marketplace') || event.urlAfterRedirects.includes('/products') || event.urlAfterRedirects.includes('/search');
            });
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLanguage = localStorage.getItem(AppConstants.CURRENT_LANG_STORE_KEY);
        }

        this.appCurrentLang = this.translationService.currentLang || AppConstants.FRENCH;
        this.langChangeSubscription = this.translationService.onLangChange.subscribe(event => {
            this.appCurrentLang = event.lang;
        });

        this.products = this.cartService.getProducts();
        this.getPricing();
        this.wishlistService.wishlistCount$.subscribe(count => {
            this.wishlistCount = count;
        });
        if (this.user && this.user.id) {
            this.wishlistService.loadWishlistCount(this.user.id);
        }
    }

    ngOnDestroy(): void {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
        if (this.routerEventsSubscription) { // NEW
            this.routerEventsSubscription.unsubscribe();
        }
    }

    getPricing() {
        return this.pricingService.get_pricings().subscribe(
            (result: IPagination) => {
                this.pricing = result.data;
            }
        );
    }

    getImageSrc(imagePath: string) {
        return imagePath !== '' && imagePath !== null && imagePath.includes('media') ?
            environment.image_cdn_url + '/' + imagePath + '?func=crop&width=45&height=45' : '/assets/images/default.jpg';
    }

    nbOfProducts(products: any) {
        this.total = 0;
        for (let i = 0; i < products.length; i++) {
            this.total += products[i].qty;
        }
        return this.total;
    }

    removeProductIntoCat(product: ProductModel) {
        this.cartService.removeItemFromCart(this.user.id, product.lineId).subscribe();
        this.storeService.removeItemFromStore(product.id);
    }

    changeLanguage(newLanguage: string) {
        if (this.availableLangs.includes(newLanguage)) {
            this.translationService.use(newLanguage)
                .subscribe(response => {
                    this.appCurrentLang = newLanguage;
                });
        } else { throw new Error('Unknown Language'); }
    }

    search() {
        const q = this.searchForm.get('q')?.value;
        // const url = this.router.url;
        // const categoryMatch = url.match(/\/products\/category\/([^?&]+)/);
        // if (categoryMatch && categoryMatch[1] !== 'all') {
        //     if (q && q.trim()) {
        //         this.router.navigate(['products', 'category', categoryMatch[1]], { queryParams: { q: q.trim() } });
        //     } else {
        //         this.router.navigate(['products', 'category', categoryMatch[1]]);
        //     }
        // } else
        if (q && q.trim()) {
            this.router.navigate(['search'], { queryParams: { q: q.trim() } });
        }
    }

    toggleMobileSearch() {
        this.mobileSearchOpen = !this.mobileSearchOpen;
    }

}